export default function sortableHeaders($timeout) {
    return {
        scope: false,
        restrict: 'EA',
        link: function link(scope, element, attr) {
            var headers = element.find(attr.headerTag || 'th');

            scope.$watch(attr.sortableHeaders + '.orderBy', () => angular.forEach(headers, updateCss));

            function updateCss(th) {
                var $th = angular.element(th);
                var autoQuery = scope.$eval(attr.sortableHeaders || attr.ngModel || attr.db || attr.qa);
                if (!autoQuery) return;
                var asc = $th.attr('asc');
                var desc = $th.attr('desc');
                $th.removeClass('sorting-asc sorting-desc sortable');
                if (autoQuery.orderBy === asc) $th.addClass('sorting-asc');
                else if (autoQuery.orderBy === desc) $th.addClass('sorting-desc');
                else if (asc || desc) $th.addClass('sortable');
            }

            function headerClicked(e) {
                var $th = angular.element(e.target);
                var autoQuery = scope.$eval(attr.sortableHeaders || attr.ngModel || attr.db || attr.qa);
                if (!autoQuery) return;
                var asc = $th.attr('asc');
                var desc = $th.attr('desc');
                autoQuery.sort(autoQuery.orderBy === asc ? desc : asc);
                angular.forEach(headers, updateCss);
                scope.$apply();
            }

            angular.forEach(headers, function initHeader(th) {
                var $th = angular.element(th);
                var sort = $th.attr('sort');
                var asc = $th.attr('asc');
                var desc = $th.attr('desc');
                if (sort || asc || desc) {
                    if (sort && !asc) $th.attr('asc', sort);
                    if (sort && !desc) $th.attr('desc', '-' + sort);
                    $timeout(() => { updateCss(th); }, 500);
                    $th.on('click', headerClicked);
                }
            });
        }
    };
};